












































import { Component, Prop, Vue } from "vue-property-decorator";
import { elementTypes } from "@/data/ElementTypes";
import { ElementTypeComplexList } from '@/data/ElementTypeModel';
import ItemProperty from "./ItemProperty.vue";

@Component({
    components: {
        ItemProperty
    }
})
export default class ItemlistProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: Array })
    value!: any[];

    get isSingleItem() {
        return this.value && (this.value.some((e) => typeof(e) === "string") || this.value.length === 1);
    }

    get singleItem() {
        return Array.isArray(this.value[0]) ? this.value[0] : this.value;
    }

    private listItemType = elementTypes.get("list_item") as ElementTypeComplexList;

    addItem() {
        const clone = JSON.parse(JSON.stringify(this.listItemType.defaultElement));
        let newValue = this.value;
        if (this.isSingleItem && newValue && !Array.isArray(newValue[0])) {
            newValue = [newValue];
        } else if (!newValue) {
            newValue = [];
        }
        newValue.push(clone);
        this.$emit("input", newValue);
    }

    removeItem(index: number) {
        const copy = this.value.slice();
        copy.splice(index, 1);
        this.$emit("input", copy);
    }

    handleItemInput(index: number, item: any) {
        const copy = this.value.slice();
        copy[index] = item;
        this.$emit("input", copy);
    }

}
